import React from 'react';
import PropTypes from 'prop-types';
import Masks from '../../../utils/masks';
import { Grid, Input, DataGrid } from '../../../components/index';
import DependentesCessacao from './DependentesCessacao';
import { fonteCessacaoPensao } from '../../../utils/listsSelect';
import SolicitanteDestinatario from '../SolicitanteDestinatario';
import { filterMotivos } from './DadosCessacaoAposentadoria';

const DadosCessacaoPensao = props => (
  <React.Fragment>
    <SolicitanteDestinatario
      requerimento={props.estadoFormulario.requerimento}
    />
    <DataGrid title="Dados do Requerimento de Pensão" icon="ico-money" >
      <div className="row">
        {props.estadoFormulario.requerimento.numeroBeneficio ?
          <Grid cols="12 12 12 12">
            <Input
              disabled
              label="NB"
              value={props.estadoFormulario.requerimento.numeroBeneficio}
            />
          </Grid>
        :
          <Grid cols="12 12 12 12">
            <Input
              disabled
              label="Matrícula Regime Instituidor"
              value={props.estadoFormulario.requerimento.matricula}
            />
          </Grid>
        }
      </div>
      <div className="row">
        <Grid cols="12 12 12 12">
          <Input
            disabled
            label="Nome"
            value={props.estadoFormulario.requerimento.nome}
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="12 12 12 12">
          <Input
            disabled
            label="Data de Início de Benefício"
            value={props.estadoFormulario.requerimento.dataInicioBeneficio}
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="12 12 6 6">
          <Input
            disabled={props.estadoFormulario.desabilitarFormulario ||
              props.estadoFormulario.totalDependentesACessar === 0}
            label="Motivo da Cessação"
            error={!props.estadoFormulario.validadeCampos.motivoCessacao}
            touched={props.estadoFormulario.touched}
            placeholder="Selecione o motivo da cessação"
            onChange={e => props.handleChange(e, 'motivoCessacao')}
            value={props.estadoFormulario.requerimento.motivoCessacao}
            itemList={props.estadoFormulario.totalDependentesACessar === 0 ?
              props.estadoFormulario.listaMotivosPensaoInativa :
              filterMotivos(props.motivosCessacaoRequerimento, props.estadoFormulario.requerimento, 'pensão')}
            number
            required
            custom
          />
        </Grid>
        <Grid cols="12 12 6 6">
          <Input
            disabled={props.estadoFormulario.desabilitarFormulario}
            label="Fonte da Cessação"
            touched={props.estadoFormulario.touched}
            placeholder="Selecione a fonte da cessação"
            onChange={e => props.handleChange(e, 'fonteCessacao')}
            value={props.estadoFormulario.requerimento.fonteCessacao}
            itemList={fonteCessacaoPensao}
            number
            custom
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="12 12 6 6">
          <Input
            disabled={props.estadoFormulario.desabilitarFormulario ||
              props.estadoFormulario.totalDependentesACessar === 0}
            label="Data da Cessação"
            error={!props.estadoFormulario.validadeCampos.dataCessacaoBeneficio}
            touched={props.estadoFormulario.touched}
            mask={Masks.date}
            onChange={e => props.handleChange(e, 'dataCessacaoBeneficio')}
            value={props.estadoFormulario.requerimento.dataCessacaoBeneficio}
            required
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="12 12 12 12">
          <Input
            disabled={props.estadoFormulario.desabilitarFormulario}
            cols="74"
            componentClass="textarea"
            label="Descrição do motivo da Cessação"
            maxlength="200"
            onChange={e => props.handleChange(e, 'descricaoMotivoCessacao')}
            rows="3"
            required={[34, 36].includes(props.estadoFormulario.requerimento.motivoCessacao)}
            value={props.estadoFormulario.requerimento.descricaoMotivoCessacao}
            textarea
          />
        </Grid>
      </div>
    </DataGrid>
    <DependentesCessacao
      acao={props.acao}
      match={props.match}
      dependentes={props.estadoFormulario.requerimento.dependentes}
      estadoFormulario={props.estadoFormulario.estadoFormulario}
      handleChangeDependentes={e => props.handleChangeDependentes(e, 'dependentes')}
    />
  </React.Fragment>
);

DadosCessacaoPensao.propTypes = {
  acao: PropTypes.string.isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  motivosCessacaoRequerimento: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  // addSemDepAtivosLabel: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChangeDependentes: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
      tipoRequerimento: PropTypes.string,
    }),
  }),
};

DadosCessacaoPensao.defaultProps = {
  match: null,
  motivosCessacaoRequerimento: null,
};

export default DadosCessacaoPensao;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Cessacao/DadosCessacaoPensao.jsx